export const FETCH_BEERS = 'FETCH_BEERS';
export const FETCH_BEER = 'FETCH_BEER'
export const SEARCH_BEER = 'SEARCH_BEER';
export const ADD_BEER = 'ADD_BEER';
export const ADD_BEER_ERR = 'ADD_BEER_ERR';
export const DELETE_BEER = 'DELETE_BEER';
export const DELETE_BEER_ERR = 'DELETE_BEER_ERR';
export const EDIT_BEER = 'EDIT_BEER';
export const EDIT_BEER_ERR = 'EDIT_BEER_ERR';